module.exports = __webpack_public_path__ + "static/media/group-40@3x.81d80002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/moneytable/group-40@3x.jpg
// module id = 86
// module chunks = 19